module.exports = __webpack_public_path__ + "uKAwi6M3jJIjqSQpK/RDC_RED_Logo_House.svg";